import React, { FC } from 'react';

import { Box, Icon } from '@rbilabs/component-library';
import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonSizes } from 'components/action-button';
import { CartOfferState } from 'generated/rbi-graphql';
import useMediaQuery from 'hooks/use-media-query';

import { messages } from './messages';
import { IButtonLabelProps } from './types';

export const ButtonLabel: FC<IButtonLabelProps> = ({ offerState = CartOfferState.INACTIVE }) => {
  const { formatMessage } = useIntl();
  const isDesktop = useMediaQuery('desktop');
  return offerState === CartOfferState.INACTIVE ? (
    <Box margin="0 auto" width="100%">
      <ActionButton
        size={isDesktop ? ActionButtonSizes.LARGE : ActionButtonSizes.SMALL}
        fullWidth
        skipLogEvent
      >
        {formatMessage(messages.activate)}
      </ActionButton>
    </Box>
  ) : (
    <Box margin="0 auto" width="100%">
      <ActionButton
        size={isDesktop ? ActionButtonSizes.LARGE : ActionButtonSizes.SMALL}
        fullWidth
        disabled
        startIcon={<Icon icon="check" color="white" />}
      >
        {formatMessage(messages.activated)}
      </ActionButton>
    </Box>
  );
};
